import { request } from "../utils/request.js"


export const customizeOutputOrder_exportForManage = (pojo, args) => request({
    url: 'customizeOutputOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeOutputOrder_findPageForManage = (pojo, args) => request({
    url: 'customizeOutputOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeOutputOrder_findPageListForManage = (pojo, args) => request({
    url: 'customizeOutputOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeOutputOrder_findPageForDeliveryManage = (pojo, args) => request({
    url: 'customizeOutputOrder/findPageForDeliveryManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeOutputOrder_findPageListForDeliveryManage = (pojo, args) => request({
    url: 'customizeOutputOrder/findPageListForDeliveryManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeOutputOrder_findPageForCurrentUserDelivery = (pojo, args) => request({
    url: 'customizeOutputOrder/findPageForCurrentUserDelivery',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeOutputOrder_findPageListForCurrentUserDelivery = (pojo, args) => request({
    url: 'customizeOutputOrder/findPageListForCurrentUserDelivery',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeOutputOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'customizeOutputOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeOutputOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'customizeOutputOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


export const customizeOutputOrder_saveIntoDraft = (pojo, args) => request({
    url: 'customizeOutputOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeOutputOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'customizeOutputOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeOutputOrder_update = (pojo, args) => request({
    url: 'customizeOutputOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeOutputOrder_updateAndSubmit = (pojo, args) => request({
    url: 'customizeOutputOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeOutputOrder_submitById = (id, args) => request({
    url: 'customizeOutputOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeOutputOrder_deleteById = (id, args) => request({
    url: 'customizeOutputOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeOutputOrder_approval = (pojo, args) => request({
    url: 'customizeOutputOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeOutputOrder_changeDistributeDelivery = (pojo, args) => request({
    url: 'customizeOutputOrder/changeDistributeDelivery',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeOutputOrder_distributeDelivery = (pojo, args) => request({
    url: 'customizeOutputOrder/distributeDelivery',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeOutputOrder_startDelivery = (id, args) => request({
    url: 'customizeOutputOrder/startDelivery',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeOutputOrder_completeDelivery = (pojo,args) => request({
    url: 'customizeOutputOrder/completeDelivery',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeOutputOrder_confirmDelivery = (id, args) => request({
    url: 'customizeOutputOrder/confirmDelivery',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeOutputOrder_findById = (id, args) => request({
    url: 'customizeOutputOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const customizeOutputOrder_findVoById = (id, args) => request({
    url: 'customizeOutputOrder/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const customizeOutputOrder_generatePrintPdf = (pojo, args) => request({
    url: 'customizeOutputOrder/generatePrintPdf',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/customizeOutputOrder.js